/**
 * Name: Customer List saga
 * Author: @Gaurav
 * Date: 20-07-2021
 */
import { put, takeLatest, call } from 'redux-saga/effects';
import ApiCaller from '../ApiCaller';

const callAPI = (payload) => {
  return ApiCaller(`/v1/admin/customers?search=${payload}`, 'GET');
};

export default function* watchRequest() {
  yield takeLatest('CUSTOMER_LIST', function* performAction(action) {
    yield put({ type: 'CUSTOMER_LIST_INITIATED' });
    try {
      const data = yield call(callAPI.bind(this, action.payload));
      yield put({ type: 'CUSTOMER_LIST_SUCCESS', payload: data });
    } catch (error) {
      yield put({ type: 'CUSTOMER_LIST_FAILED', payload: error });
    }
  });
}
